import './cancelBooking.css';

// note: extra line under the refund (e.g. the stay's cancellation rule);
// confirmDisabled: the booking can't be cancelled (note says why)
const ConfirmationModal = ({
    setShowModal,
    handleConfirm,
    message,
    refundAmount = null,
    note = null,
    confirmDisabled = false
}) => {
    const handleClose = (e) => {
        e.stopPropagation();
        setShowModal(false);
    };

    return (
        <div className='modal'>
            <div className='modal-content'>
                <p className='modal-title'>
                    {message}
                    {refundAmount !== null && !confirmDisabled && (
                        <span className='refund-amount'>You will receive ₹{refundAmount}</span>
                    )}
                    {note && <span className='refund-note'>{note}</span>}
                </p>
                <button onClick={handleConfirm} className='confirm-btn' disabled={confirmDisabled}>
                    Yes
                </button>
                <button onClick={handleClose} className='cancel-btn'>
                    No
                </button>
            </div>
        </div>
    );
};

export default ConfirmationModal;
